import React from 'react';
import pdfIcon from '@/assets/icons/pdfIcon.png'
import jpgIcon from '@/assets/icons/jpgIcon.png'
import zipIcon from '@/assets/icons/zipIcon.png'
import DeleteIcon from "@mui/icons-material/Delete"

export type FileInfo = {
    name: string;
    size: number;
    type: string;
    url: string; 
};

type FileCardProps = {
    file : FileInfo;
    editFiles : boolean;
    onEliminar: () => void;
};

function obtenerIconoArchivo(tipo: string) {
    if (tipo.includes('pdf')) return pdfIcon;
    if (tipo.includes("jpg")||tipo.includes("jpeg")) return jpgIcon;
    if (tipo.includes("zip")) return zipIcon;
    return '';
}

export const FileCard: React.FC<FileCardProps> = ({ file, editFiles ,onEliminar }) => {
    const icono = obtenerIconoArchivo(file.type);

    return (
        <div className = "flex flex-col w-8 h-8 md: w-[100%] h-[100%] m-2 justify-center items-center p-2 relative">
            {editFiles &&
                  <DeleteIcon className="text-red-600 place-self-end" onClick={onEliminar}/>
            }
            <a 
            className="flex flex-col w-[100%] h-[100%]"
            target ="_blank"
            rel = "noopener noreferrer"
            download={file.name}
            href = {file.url}
            tabIndex={0}
            aria-label={`Descargar archivo ${file.name}`}
            >
                <img
                    className = "place-self-center size-24"
                    src = {icono}
                    alt = {file.type}
                />
                <div className="flex justify-center h-[20%] w-full">
                    <p className=" truncate text-wrap line-clamp-1 break-all wrap-anywhere">{file.name}</p>
                </div>
                
            </a>
        </div>
    );
};